import { useCallback } from 'react';
import { selectMessages } from 'state/selectors';
import { chatStore } from 'state/store';
import { MessageType } from 'state/store/chat/type';
import { isFeatureOn } from 'useCase/featureFlags/featureFlagsApi';
import { FEATURES } from 'consts';

type SaveMessageType = { text: string; own: boolean; name: string; senderId: string; sid: string };

export const useChat = () => {
    const setIsScrolled = useCallback((isScrolled: boolean) => {
        chatStore.setIsScrolled(isScrolled);
    }, []);

    const setMessages = useCallback((messages: MessageType[]) => {
        chatStore.setMessages(messages);
    }, []);

    const updateNewMessageCount = useCallback(() => {
        chatStore.updateNewMessageCount();
    }, []);

    const resetNewMessageCount = useCallback(() => {
        chatStore.resetNewMessageCount();
    }, []);

    const setMessageInput = useCallback((input: string) => {
        chatStore.setMessageInput(input);
    }, []);

    const prepareAndAddMessage = useCallback(({ text, own, name, senderId, sid }: SaveMessageType) => {
        const previousMessages = selectMessages();
        const lastMessage = previousMessages.length > 0 ? previousMessages[previousMessages.length - 1] : null;

        const showName = !lastMessage || lastMessage.senderId !== senderId;
        if (lastMessage && lastMessage.senderId === senderId) {
            previousMessages[previousMessages.length - 1] = {
                ...lastMessage,
                last: false,
            };
        }

        const message: MessageType = {
            text,
            name,
            time: `${String(new Date().getHours()).padStart(2, '0')} : ${String(new Date().getMinutes()).padStart(
                2,
                '0',
            )}`,
            own,
            senderId,
            showName,
            sid,
            last: true,
            timeMs: Date.now(),
        };
        setMessages([...previousMessages, message]);
    }, []);

    const isChatOn = useCallback(() => {
        return isFeatureOn(FEATURES.VCS_CHAT_ENABLED);
    }, []);

    return {
        setIsScrolled,
        isChatOn,
        setMessageInput,
        updateNewMessageCount,
        resetNewMessageCount,
        prepareAndAddMessage,
    };
};
